import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const SDescription = styled.div<{ isPromo: boolean }>`
    ${FONTS.XS};
    color: ${({ isPromo }) => isPromo ? COLORS.TextInfo : COLORS.TextHint};
    white-space: break-spaces;
`;
